import { APIConfig } from 'src/config';
import { GetAllUserProductsResponse, GetUserProductResponse, UserProduct } from 'src/interfaces/userProduct/user-product';
import axiosClient from '../utils/axios-client';

class UserProductApi {
  private requestManagementUrl = APIConfig.requestManagementUrl;

  async getAllUserProducts(userId: string):
  Promise<{ responseData: GetAllUserProductsResponse, statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.requestManagementUrl}userProduct/all/${userId}`).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.symptoms
      });
    }
  }

  // calls POST api to add userProduct in the database
  async addUserProduct(userProduct: UserProduct):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.post(`${this.requestManagementUrl}userProduct`, userProduct).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // get userProduct details by userProduct Id
  async getUserProductById(userProductId: string):
  Promise<{ responseData: GetUserProductResponse, statusCode: number }> {
    try {
      const res = await axiosClient.get(`${this.requestManagementUrl}userProduct/${userProductId}`).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // calls PUT api to updateUserProduct in the database
  async updateUserProduct(updateUserProduct: UserProduct):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.put(`${this.requestManagementUrl}userProduct`, updateUserProduct).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }

  // calls PUT api to updateUserProduct in the database
  async updateUserProductWeb(updateUserProduct: UserProduct):
  Promise<{ responseData: any, statusCode: number }> {
    try {
      const res = await axiosClient.put(`${this.requestManagementUrl}userProduct/update`, updateUserProduct).then((response) => response);
      return Promise.resolve({
        responseData: res.data,
        statusCode: res.status
      });
    } catch (error) {
      console.log(error);
      return Promise.resolve({
        responseData: error.response.data,
        statusCode: error.response.status
      });
    }
  }
}

export const userProductApi = new UserProductApi();
